import { createSlice } from "@reduxjs/toolkit";


const securitySlice = createSlice({
    name: 'security',
    initialState: {
        encodedPayload: ''
    },
    reducers: {
        setEncodedPayload(state, action) {
            state.encodedPayload = action.payload;
        }
    }
})


export const securityActions = securitySlice.actions;
export default securitySlice;